import { IconName } from '../components/ui/icons/types';
import countryData from '../components/ui/PhoneInput/country-data';

const urlPattern =
  /^(https?:\/\/)(([-_~.%a-z0-9а-я]+\.[a-zа-я]{2,10}(:\d+)?)|localhost(:\d+)?)(\/\S*)*$/i;

const onlyLocalhostHttpUrlPattern =
  /^(https:\/\/([-_~.%a-z0-9а-я]+\.[a-zа-я]{2,10}(:\d+)?)|https?:\/\/localhost(:\d+)?)(\/\S*)*$/i;

const deepLinkPattern =
  /^([-_.a-z0-9а-я]{2,32}):\/\/([\w_-]+(?:(?:\.[\w_-]+)?))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;

const emailPattern =
  /^[a-zA-Zа-яА-Я0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Zа-яА-Я0-9-]+(?:\.[a-zA-Zа-яА-Я0-9-]+)*$/i;

const hexColorPattern = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i;

const allowedSymbol = /^[a-zA-Z0-9_\\.\-+/]*$/;

const noSpaces = /^\S*$/;

export const validateUrlLink = (link: string): boolean => urlPattern.test(link);

export const validateOnlyLocalhostHttpUrlPattern = (link: string): boolean =>
  onlyLocalhostHttpUrlPattern.test(link);

export const validateMobileDeepLink = (link: string): boolean => deepLinkPattern.test(link);

export const validateEmail = (email: string): boolean => emailPattern.test(email);

export const validateHexColor = (color: string): boolean => hexColorPattern.test(color);

export const validatePhone = (phone: string, country: IconName): boolean => {
  const data = countryData[country];
  const maxDigits = data.mask.replaceAll(/[() \-_]/g, '').length;
  const minDigits = data.minDigits ?? maxDigits;
  const prefix = `+${data.code}`;

  if (!phone.startsWith(prefix)) {
    return false;
  }

  const nationalLength = phone.length - prefix.length;

  return nationalLength >= minDigits && nationalLength <= maxDigits;
};

export const validatePlatformFields = (email: string | null): boolean =>
  allowedSymbol.test(email as string);

export const validateServerCustomId = (serverCustomId: string): boolean =>
  noSpaces.test(serverCustomId);

export const hasUrlPath = (url: string): boolean => {
  try {
    const { pathname, search, hash } = new URL(url);
    // Trailing slash alone (e.g. https://example.com/) is accepted by the backend
    return pathname.length > 1 || search !== '' || hash !== '';
  } catch {
    return false;
  }
};
